import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toAssetUrl } from "../api/api";
import "../styles/CategoryBarChart.css";

/**
 * Horizontal ranked bar chart of active post counts per category.
 * `categories` comes from the categories API ({ id, name, image, ... }).
 * `counts` is a map of categoryId -> count.
 * Each row links through to the Posts page, pre-filtered to that category.
 */
export default function CategoryBarChart({ categories, counts }) {
  const [ready, setReady] = useState(false);

  const rows = categories
    .map((cat) => ({ ...cat, count: counts[cat.id] ?? 0 }))
    .sort((a, b) => b.count - a.count);

  const maxCount = Math.max(1, ...rows.map((r) => r.count));

  useEffect(() => {
    const t = requestAnimationFrame(() => setReady(true));
    return () => cancelAnimationFrame(t);
  }, []);

  return (
    <div className="barchart">
      {rows.map((row, index) => (
        <Link
          key={row.id}
          to={`/posts?category=${row.id}`}
          className={"barchart-row" + (index === 0 ? " barchart-row-top" : "")}
        >
          <div className="barchart-row-label">
            {row.image ? (
              <img className="barchart-icon-img" src={toAssetUrl(row.image)} alt="" />
            ) : (
              <span className="barchart-icon-fallback" />
            )}
            <span className="barchart-name">{row.name}</span>
            {index === 0 && row.count > 0 && <span className="barchart-top-tag">Top</span>}
          </div>

          <div className="barchart-track">
            <div
              className="barchart-fill"
              style={{ width: ready ? `${(row.count / maxCount) * 100}%` : "0%" }}
            />
          </div>

          <div className="barchart-value">{row.count}</div>
        </Link>
      ))}
    </div>
  );
}